<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="渠道名称">
              <a-input
                placeholder="请输入渠道名称"
                v-model="queryParam.cname"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="场景">
              <a-select v-model="queryParam.scene" placeholder="请选择场景">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option disabled value="1">小程序</a-select-option>
                <a-select-option value="2">二维码</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="需要验证">
              <a-select v-model="queryParam.needVerify" placeholder="请选择">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="1">是</a-select-option>
                <a-select-option value="0">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8" v-if="toggleSearchStatus">
            <a-form-item label="类型">
              <a-select v-model="queryParam.ctype" placeholder="请选择类型">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="0">单人</a-select-option>
                <a-select-option value="1">多人</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <!--展开按钮，控制toggleSearchStatus状态-->
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
              <!--展开按钮结束-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus"
        >新增渠道</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <!--下拉栏显示的菜单， 通过slot="overlay"控制-->
        <a-menu slot="overlay">
          <!--  批量删除操作        -->
          <a-menu-item @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <!--下拉菜单的默认显示结束-->
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a
          style="font-weight: 600"
          >{{ selectedRowKeys.length }}</a
        >项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <!--
        :pagination="ipagination" -->
      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        :rowKey="r => r.id"
        @change="handleTableChange"
      >
        <template slot="ctype" slot-scope="text">
          {{ text == '0' ? '单人' : '多人' }}
        </template>
        <template slot="needVerify" slot-scope="text">
          {{ text == '1' ? '是' : '否' }}
        </template>
        <template slot="scene" slot-scope="text">
          {{ text == true ? '小程序' : '扫描二维码' }}
        </template>
        <template slot="avatarslot" slot-scope="text, record">
          <div class="anty-img-wrap">
            <a-avatar
              shape="square"
              :src="getAvatarView(record.avatar)"
              icon="user"
            />
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)" v-has="'user:edit'">编辑</a>-->
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a @click="handleQrcode(record.qrCode)">查看二维码</a>

          <!-- <a-divider type="vertical" />
          <a @click="JumpChatInfoview(record)">查看客户</a> -->

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <channelModal ref="modalForm" @ok="modalFormOk"></channelModal>

    <!-- :confirm-loading="confirmLoading" -->
    <a-modal
      title="查看二维码"
      :visible="visible"
      @ok="visible = false"
      @cancel="visible = false"
    >
      <img :src="qrPng" alt="" />
      <!-- <a-input-search placeholder="请输入使用人员姓名" style="width: 200px;margin-bottom: 20px;"
        allowClear @search="onSearch" />
        <a-table :columns="columnsModal" :data-source="customerList" :pagination=false>
          <span slot="action" slot-scope="text, record">
            <a href="javascript:viod(0)" @click="toJump(record.userId)">查看客户</a>
          </span>
        </a-table> -->
    </a-modal>
  </a-card>
</template>

<script>
import pick from 'lodash.pick';
import moment from 'moment';
import Vue from 'vue';
// import JSelectPosition from '@/components/jeecgbiz/JSelectPosition'
// import departWindow from '../../system/modules/DepartWindow'
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getFileAccessHttpUrl } from '@/api/manage';
import { addMember, editUser, queryUserRole, queryall } from '@/api/api';
import { disabledAuthFilter } from '@/utils/authFilter';

import channelModal from './channelModal';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';

export default {
  name: 'channelManagement',
  mixins: [JeecgListMixin],
  components: {
    channelModal
  },
  data() {
    return {
      qrPng: '',
      description: '这是企业微信销售渠道管理页面',
      queryParam: {},
      recycleBinVisible: false,
      columns: [
        {
          title: '渠道名称',
          align: 'center',
          dataIndex: 'cname',
          customRender: function(text) {
            return !text
              ? ''
              : text.length > 10
              ? text.substr(0, 10) + '...'
              : text;
          }
        },
        {
          title: '类型',
          align: 'center',
          dataIndex: 'ctype',
          scopedSlots: {
            customRender: 'ctype'
          }
        },
        {
          title: '场景',
          align: 'center',
          dataIndex: 'scene',
          scopedSlots: {
            customRender: 'scene'
          }
        },
        {
          title: '需要验证',
          align: 'center',
          dataIndex: 'needVerify',
          scopedSlots: {
            customRender: 'needVerify'
          }
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'ctime'
        },
        {
          title: '使用人员数',
          align: 'center',
          dataIndex: 'ucount'
        },
        {
          title: '获取客户数',
          align: 'center',
          dataIndex: 'ccount'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center'
        }
      ],
      columnsModal: [
        {
          title: '使用人员',
          align: 'center',
          dataIndex: 'user'
        },
        {
          title: '获取客户数',
          align: 'center',
          dataIndex: 'kcount',
          scopedSlots: {
            customRender: 'action'
          }
        }
      ],
      url: {
        list: 'wechatwork-users-biz/wechatwork/channel/list',
        delete: 'wechatwork-users-biz/wechatwork/channel/delete',
        deleteBatch: 'wechatwork-users-biz/wechatwork/channel/deleteBatch'
      },
      title: '操作',
      visible: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      recordRow: {},
      customerList: [
        {
          user: '时间的',
          kcount: 30
        },
        {
          user: '时间1',
          kcount: 31
        },
        {
          user: '时间4',
          kcount: 33
        },
        {
          user: '时3的',
          kcount: 35
        }
      ]
    };
  },
  computed: {
    importExcelUrl: function() {
      return `${process.env.GATEWAY + process.env.VUE_APP_CMS_SYSTEM}/${
        this.url.importExcelUrl
      }`;
    }
  },
  methods: {
    // modalFormOk() {
    //   this.loadData();
    // },
    handleQrcode(qrPng) {
      this.visible = true;
      this.qrPng = qrPng;
    },
    onSearch() {
      this.customerList = [
        {
          user: '时间4',
          kcount: 33
        },
        {
          user: '时3的',
          kcount: 35
        }
      ];
    },
    onChange(date, dateString) {
      console.log(date, dateString);
      this.queryParam.ctime = dateString.join(' - ');
    },
    getAvatarView: function(avatar) {
      return getFileAccessHttpUrl(avatar);
    },
    handleMenuClick(e) {
      console.log('点击批量删除按钮');
      if (e.key === '1') {
        console.log('批量删除');
        this.batchDel();
      }
    },
    handleChangePassword(username) {
      this.$refs.passwordmodal.show(username);
    },
    JumpChatInfoview(record) {
      this.recordRow = record;
      this.visible = true;
    },
    toJump(userId) {
      let id = userId || this.recordRow.userId;
      this.$router.push({
        path: '/wechatwork/supervision/chatDataList',
        query: {
          id,
          type: 1
        }
      });
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
